// const baseURL = 'https://localhost:44389/api/';
 const baseURL = 'https://nflsapi.dotregistration.co.in/api/';

export const LOGIN_URL = `${baseURL}Account/userlogin`;
export const CHANGE_PASSWORD = `${baseURL}Account/changepassword`;
export const GET_REGION_BY_STATE_ID = `${baseURL}Masters/getregionssbystateid`;
export const GET_REGION_BY_ID = `${baseURL}Masters/getregionbyid`;
export const ADD_UPDATE_REGION = `${baseURL}Masters/addupdateregion`;
export const GET_DISTRICT_BY_REGION_ID = `${baseURL}Masters/getdistrictsbyregionid`;
export const GET_DISTRICT_BY_ID = `${baseURL}Masters/getdistrictbyid`;
export const ADD_UPDATE_DISTRICT = `${baseURL}Masters/addupdatedistrict`;
export const GET_USERS = `${baseURL}Masters/getusers`;
export const GET_USER_BY_ID = `${baseURL}Masters/getuserbyid`;
export const ADD_UPDATE_USER = `${baseURL}Masters/addupdateuser`;
export const UPDATE_USER_STATUS = `${baseURL}Masters/updateuserstatus`;
export const GET_EVENT_CATEGORY = `${baseURL}Masters/geteventcategories`;
export const GET_EVENT_CATEGORY_BY_ID = `${baseURL}Masters/geteventcategorybyid`;
export const ADD_UPDATE_EVENT_CATEGORY = `${baseURL}Masters/addupdateeventcategory`;
export const GET_ANNUAL_BUDGET_BY_CATEGORY_ID = `${baseURL}Masters/getannualbudgetbycategoryid`;
export const GET_ANNUAL_BUDGET_BY_ID = `${baseURL}Masters/getannualbudgetbyid`;
export const ADD_UPDATE_EVENT_CATEGORY_ANNUAL_BUDGET = `${baseURL}Masters/addupdateeventcategoryannualbudget`;

export const GET_NFLS_REGISTRATIONS = `${baseURL}Admin/getnflsregistrationbysearch`;
export const UPDATE_NFLS_REGISTRATION_VERIFICATION = `${baseURL}Admin/updatenflsregistrationverification`;
export const UPDATE_NFLS_DOCUMENT_VERIFICATION = `${baseURL}Admin/updatenflsdocumentverification`;
export const GET_NFLS_REGISTRATION_BY_ID = `${baseURL}Applicant/getnflsregistrationbyid`;
export const GET_NFLS_DOCUMENTS_BY_ID = `${baseURL}Applicant/getnflsdocumentsbyid`;
export const GET_NFLS_CERTIFICATE_NUMBER = `${baseURL}Admin/getnflscertificatenumber`;
export const GET_NFLS_CERTIFICATE_BY_ID = `${baseURL}Admin/getnflscertificatebyid`;
export const ADD_UPDATE_NFLS_CERTIFICATE = `${baseURL}Admin/addupdatenflscertificate`;

export const GET_SPONSORSHIP = `${baseURL}Admin/getsponsorshipbysearch`;
export const UPDATE_SPONSORSHIP_REGISTRATION_VERIFICATION = `${baseURL}Admin/updatesponsorshipverification`;
export const UPDATE_SPONSORSHIP_DOCUMENT_VERIFICATION = `${baseURL}Admin/updatesponsorshipdocumentverification`;
export const GET_SPONSROSHIP_BY_ID = `${baseURL}Applicant/getsponsorshipbyid`;
export const GET_SPONSORSHIP_DOCUMENTS_BY_ID = `${baseURL}Applicant/getsponsorshipdocumentsbyid`;
export const UPDATE_SPONSORSHIP_DETAILS = `${baseURL}Admin/updatesponsorshipdetails`;
export const UPDATE_SPONSORSHIP_EMAIL_DETAILS = `${baseURL}Admin/updatesponsorshipemaildetails`;
export const GET_SPONSORSHIP_CERTIFICATE_NUMBER = `${baseURL}Admin/getsponsorshipcertificatenumber`;
export const GET_SPONSORSHIP_CERTIFICATE_BY_ID = `${baseURL}Admin/getsponsorshipcertificatebyid`;
export const ADD_UPDATE_SPONSORSHIP_CERTIFICATE = `${baseURL}Admin/addupdatesponsorshipcertificate`;
export const GET_SPONSORSHIP_PAYMENT_BY_SPONSORSHIP_ID = `${baseURL}Admin/getsponsorshippaymentbysponsorshipid`;
export const GET_SPONSORSHIP_PAYMENT_BY_ID = `${baseURL}Admin/getsponsorshippaymentbyid`;
export const ADD_UPDATE_SPONSORSHIP_PAYMENT = `${baseURL}Admin/addupdatesponsorshippayment`;
export const GET_SPONSORSHIP_INVOICE_BY_SPONSORSHIP_ID = `${baseURL}Admin/getsponsorshipinvoicebysponsorshipid`;
export const GET_SPONSORSHIP_INVOICE_BY_ID = `${baseURL}Admin/getsponsorshipinvoicebyid`;
export const ADD_UPDATE_SPONSORSHIP_INVOICE = `${baseURL}Admin/addupdatesponsorshipinvoice`;
export const UPDATE_SPONSORSHIP_INVOICE_STATUS = `${baseURL}Admin/updatesponsorshipinvoicestatus`;


export const GET_EVENT_BY_CATEGORY_ID = `${baseURL}Admin/geteventbycategoryid`;
export const GET_EVENT_BY_ID = `${baseURL}Admin/geteventbyid`;
export const ADD_UPDATE_EVENT = `${baseURL}Admin/addupdateevent`;
export const GET_QUOTATION_BY_EVENT_ID = `${baseURL}Admin/getquotationbyeventid`;
export const GET_QUOTATION_BY_ID = `${baseURL}Admin/getquotationbyid`;
export const ADD_UPDATE_QUOTATION = `${baseURL}Admin/addupdatequotation`;
export const DELETE_QUOTATION = `${baseURL}Admin/deletequotation`;
export const GET_WORK_ORDER_BY_EVENT_ID = `${baseURL}Admin/getworkorderbyeventid`;
export const GET_WORK_ORDER_BY_ID = `${baseURL}Admin/getworkorderbyid`;
export const ADD_UPDATE_WORK_ORDER = `${baseURL}Admin/addupdateworkorder`;
export const GET_PAYMENT_BY_WORK_ORDER_ID = `${baseURL}Admin/getpaymentbyworkorderid`;
export const GET_PAYMENT_BY_ID = `${baseURL}Admin/getpaymentbyid`;
export const ADD_UPDATE_PAYMENT = `${baseURL}Admin/addupdatepayment`;
export const GET_INVOICE_BY_WORK_ORDER_ID = `${baseURL}Admin/getinvoicebyworkorderid`;
export const GET_INVOICE_BY_ID = `${baseURL}Admin/getinvoicebyid`;
export const ADD_UPDATE_INVOICE = `${baseURL}Admin/addupdateinvoice`;
export const UPDATE_INVOICE_STATUS = `${baseURL}Admin/updateinvoicestatus`;

export const DOWNLOAD_FILE = `${baseURL}Admin/downloadfile`;

export const GET_REGION_WISE_DASHBOARD = `${baseURL}Admin/getregionwisedashboard`;

export const GET_NFLS_REGISTRATION_REPORT = `${baseURL}Admin/getnflsregistrationreport`;
export const GET_SPONSORSHIP_REPORT = `${baseURL}Admin/getsponsorshipreport`;
export const GET_APPROVED_NFLS_REGISTRATION_REPORT = `${baseURL}Admin/getapprovednflsregistrationreport`;
export const GET_APPROVED_SPONSORSHIP_REPORT = `${baseURL}Admin/getapprovedsponsorshipreport`;
export const GET_ANNUAL_BUDGET_REPORT = `${baseURL}Admin/getannualbudgetreport`;

 


// *************************************************************************************************************************

export default LOGIN_URL;